import {
  IClearSiteDetail,
  IFetchNudgeStatusFailure,
  IFetchNudgeStatusRequest,
  IFetchNudgeStatusSuccess,
  IFetchSiteListFailure,
  IFetchSiteListRequest,
  IFetchSiteListSuccess,
  IFetchSiteListSuccessPayload,
  INudgeStatus,
  ISetSiteDetail,
  ISiteDetail
} from '../site/types';
import * as actionTypes from './actionTypes';
import * as SITE_LIST_TYPES from './actionTypes';

export const fetchSiteListRequest = ({
  regionId,
  skip,
  limit,
  search,
  userBased,
  isHF4User,
  failureCb
}: {
  regionId: number;
  skip: number;
  limit: number | null;
  search?: string;
  userBased?: boolean;
  isHF4User?: boolean;
  failureCb?: (error: Error) => void;
}): IFetchSiteListRequest => ({
  type: SITE_LIST_TYPES.FETCH_SITE_LIST_REQUEST,
  skip,
  limit,
  regionId,
  search,
  userBased,
  isHF4User,
  failureCb
});

export const fetchSiteListSuccess = (payload: IFetchSiteListSuccessPayload): IFetchSiteListSuccess => ({
  type: SITE_LIST_TYPES.FETCH_SITE_LIST_SUCCESS,
  payload
});

export const fetchSiteListFailure = (error: Error): IFetchSiteListFailure => ({
  type: SITE_LIST_TYPES.FETCH_SITE_LIST_FAILURE,
  error
});

export const setSiteDetail = (payload: Partial<ISiteDetail>): ISetSiteDetail => ({
  type: SITE_LIST_TYPES.SET_SITE_DETAIL,
  payload
});

export const clearSiteDetail = (): IClearSiteDetail => ({
  type: SITE_LIST_TYPES.CLEAR_SITE_DETAIL
});

export const fetchNudgeStatusRequest = ({
  hf4User,
  key,
  tenantIds,
  successCb,
  failureCb
}: Omit<IFetchNudgeStatusRequest, 'type'>) => ({
  type: actionTypes.FETCH_NUDGE_STATUS_REQUEST,
  hf4User,
  key,
  tenantIds,
  successCb,
  failureCb
});

export const fetchNudgeStatusSuccess = (
  payload: Omit<INudgeStatus, 'loading' | 'error'>
): IFetchNudgeStatusSuccess => ({
  type: actionTypes.FETCH_NUDGE_STATUS_SUCCESS,
  payload
});

export const fetchNudgeStatusFailure = (error: any): IFetchNudgeStatusFailure => ({
  type: actionTypes.FETCH_NUDGE_STATUS_FAILURE,
  error
});

export const closeNudge = () => ({
  type: actionTypes.CLOSE_NUDGE
});
